import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TrackingService } from '../../services/tracking.service';

@Component({
  selector: 'app-pre-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <div class="pre-header">
      <div class="pre-header-container">
        <div class="contact-info">
          <a href="tel:+917550196844" class="contact-item" (click)="onPhoneClick()">
            <svg class="contact-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            <span>+91 75501 96844</span>
          </a>
          <a href="mailto:enquiry@kalaivani.in" class="contact-item" (click)="onEmailClick()">
            <svg class="contact-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            <span>enquiry&#64;kalaivani.in</span>
          </a>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .pre-header {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      background: var(--accent-color);
      z-index: 1001;
      padding: 8px 0;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .pre-header-container {
      max-width: 1400px;
      margin: 0 auto;
      padding: 0 40px;
      display: flex;
      align-items: center;
    }

    .contact-info {
      display: flex;
      gap: 24px;
      align-items: center;
    }

    .contact-item {
      display: flex;
      align-items: center;
      gap: 8px;
      color: rgba(255, 255, 255, 0.95);
      text-decoration: none;
      font-size: 0.875rem;
      font-weight: 500;
      transition: all 0.3s ease;
      padding: 4px 8px;
      border-radius: 4px;
    }

    .contact-item:hover {
      color: #ffffff;
      background: rgba(255, 255, 255, 0.15);
      transform: translateY(-1px);
    }

    .contact-icon {
      width: 16px;
      height: 16px;
      transition: all 0.3s ease;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .contact-item:hover .contact-icon {
      transform: scale(1.1);
    }

    @media (max-width: 968px) {
      .pre-header-container {
        padding: 0 20px;
      }
    }

    @media (max-width: 768px) {
      .pre-header {
        display: none;
      }
    }
  `]
})
export class PreHeaderComponent {
  private readonly trackingService = inject(TrackingService);

  onPhoneClick(): void {
    this.trackingService.trackPhoneClick('pre_header_phone');
  }

  onEmailClick(): void {
    this.trackingService.trackEmailClick('pre_header_email');
  }
}
